export default __webpack_public_path__ + "static/media/helloMyNameIs.361e65f5.png";